import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {
    DuplicateExportError,
    httpCreateSiarBulkExport,
    HttpCreateSiarBulkExportPayload
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useStoreSiarBulkExport = (
    options?: Omit<
        UseMutationOptions<Blob, AxiosError<DuplicateExportError>, HttpCreateSiarBulkExportPayload>,
        'mutationKey' | 'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.BULK_SIAR_EXPORT],
        mutationFn: payload => httpCreateSiarBulkExport({payload}),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY]})
            options?.onSettled?.(...args)
        }
    })
}
